'use client';

import { useTranslations } from 'next-intl';
import { PageToolbar } from '../../../PageToolbar/PageToolbar';
import { SecondaryHeaderContainer } from '../../../SecondaryHeaderContainer/SecondaryHeaderContainer';

type PromotionsHeaderVariant = 'toolbar' | 'secondary';

type PromotionsToolbarVariantProps = {
  variant: PromotionsHeaderVariant;
  children: React.ReactNode;
};

/**
 * Renders the header for the promotions page.
 *
 * Displays either a PageToolbar with the offers title (`toolbar`, ie /promotions) or a SecondaryHeaderContainer (`secondary`, ie /casino/offers),
 * wrapping the provided children.
 *
 * @param {Object} props - The component props.
 * @param {PromotionsHeaderVariant} props.variant - The header variant to render.
 * @param {React.ReactNode} props.children - The content to display within the header.
 * @returns {JSX.Element} The rendered promotions header.
 */
function PromotionsHeader({ variant, children }: PromotionsToolbarVariantProps) {
  const t = useTranslations('offers');
  return variant === 'toolbar' ? (
    <PageToolbar title={t('title')} className="ll-container-full py-4" breakpoint="lg" data-track-sub-navigation-title="Offers">
      <div className="flex justify-center w-full px-4">{children}</div>
    </PageToolbar>
  ) : (
    <SecondaryHeaderContainer title="" namespace="" className="ll-container-full">
      <div className="ll-container-inner mx-auto">{children}</div>
    </SecondaryHeaderContainer>
  );
}

export { PromotionsHeader, type PromotionsHeaderVariant };
